// Bun inlines configured PUBLIC_* values. Its dev server can leave an unset
// variable as a process reference, which browsers do not provide.
let configured: string | undefined;
try {
  configured = process.env.PUBLIC_ROUTINE_VIDEO_ENABLED;
} catch {
  configured = undefined;
}

// Hosted builds opt in only after their backend is ready. A local browser
// keeps the feature enabled unless explicitly testing a disabled preview.
export const routineVideoEnabled = configured === "true" ||
  (configured !== "false" && typeof window !== "undefined" &&
    ["localhost", "127.0.0.1", "[::1]"].includes(window.location.hostname));
